import { themeVariables } from '@noths/polaris-design-system-abstract-theme';
import { css } from 'styled-components';

const { colors, spacing, typography } = themeVariables;

/* No sizing token for a third party's mark. */
const LOGO_HEIGHT = '15px';

export const row = css`
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: var(${spacing.sm});
`;

export const logo = css`
  display: block;
  height: ${LOGO_HEIGHT};
  width: auto;
`;

/** `700` is a literal: the theme has one body weight and no bold step. */
export const link = css`
  display: inline-flex;
  align-items: center;
  gap: var(${spacing.xxs});
  font-family: var(${typography.body.fontFamily});
  font-size: var(${typography.body.sizes.md.fontSize});
  font-weight: 700;
  line-height: var(${typography.body.sizes.md.lineHeight});
  letter-spacing: var(${typography.body.letterSpacing});
  color: var(${colors.content.link});
  text-decoration: underline;
`;
